import { Alert as MuiAlert, Slide, Snackbar } from '@mui/material';
import React, { useContext } from 'react';
import OrdersContext from '../../Context/Orders/OrdersContext';

function SlideTransition(props) {
	return <Slide {...props} direction='right' />;
}

const Alert = React.forwardRef((props, ref) => (
	<MuiAlert elevation={6} ref={ref} variant='filled' {...props} />
));
export default function ToastAlert() {
	const { toastAlert, toogleToastAlert } = useContext(OrdersContext);
	const { severity, open, message } = toastAlert;
	return (
		<Snackbar
			open={open}
			autoHideDuration={4000}
			TransitionComponent={SlideTransition}
			onClose={() => toogleToastAlert(severity, false)}
		>
			<Alert
				onClose={() => toogleToastAlert(severity, false)}
				severity={severity}
				sx={{ width: '100%' }}
			>
				{message}
			</Alert>
		</Snackbar>
	);
}
